var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"embed-responsive embed-responsive-16by9 z-depth-1-half"},[(_vm.document)?_c('b-embed',{attrs:{"type":"iframe","src":_vm.document.content,"width":"100%","height":"900","allowfullscreen":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }